import { useCallback, useMemo, useState } from "react";

export const useSlideShow = (totalSlides = 0) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = useCallback(() => {
    setCurrentIndex((i) => (i + 1 < totalSlides ? i + 1 : i));
  }, [totalSlides]);

  const previous = useCallback(() => {
    setCurrentIndex((i) => (i > 0 ? i - 1 : 0));
  }, []);

  const reset = useCallback(() => setCurrentIndex(0), []);

  const setIndex = useCallback(
    (index) => {
      if (index >= 0 && index < totalSlides) {
        setCurrentIndex(index);
      }
    },
    [totalSlides],
  );

  const slideshow = useMemo(() => {
    return {
      currentIndex,
      next,
      previous,
      reset,
      setIndex,
      totalSlides,
    };
  }, [currentIndex, next, previous, reset, setIndex, totalSlides]);

  return slideshow;
};
